export const LaunchView = {
    Parameters: 0,
    Decisions: 1,
    Results: 2,
    Conclusions: 3
}
